import { getCarousel } from "src/api/rest/carousel"
import { saveCarouselLocal } from "src/utils/localstorage"
import {
    getCachedData,
    setCachedData,
    CACHE_KEYS,
    CACHE_DURATIONS,
} from "src/utils/cache"

const SET_CAROUSEL = "CAROUSEL/SET_CAROUSEL"

const initState = {
    carousel: [],
}

export default function(state = initState, action) {
    const { type, payload } = action

    const cases = {
        [SET_CAROUSEL]: () => {
            return {
                ...state,
                carousel: payload,
            }
        },
    }
    return cases[type] ? cases[type]() : state
}

export const setCarousel = items => ({ type: SET_CAROUSEL, payload: items })

// Loads the carousel offer from the 30-minute cache or, on a cache miss /
// forceRefresh, from Shop-api. Resolves to the list it dispatched (cached or
// fresh), or to null when nothing usable was loaded — syncBasketWithMenu
// checks basket prices only against a list returned here, never against the
// copy restored from localStorage (SUSHI-435). A failed request (getCarousel
// then resolves to undefined) or a response that is not a list is neither
// dispatched nor cached, so the list already shown stays in place — the
// Carousel component needs an array.
export const fetchCarousel = (forceRefresh = false) => {
    return async dispatch => {
        try {
            // Check cache first (unless force refresh is requested)
            if (!forceRefresh) {
                const cachedCarousel = getCachedData(
                    CACHE_KEYS.CAROUSEL,
                    CACHE_DURATIONS.LONG
                )
                if (Array.isArray(cachedCarousel)) {
                    dispatch(setCarousel(cachedCarousel))
                    return cachedCarousel // Exit early with cached data
                }
            }

            // Fetch fresh data if cache miss or force refresh
            const items = await getCarousel()
            if (!Array.isArray(items)) return null
            dispatch(setCarousel(items))

            // Cache with both new cache system and legacy localStorage
            setCachedData(CACHE_KEYS.CAROUSEL, items)
            saveCarouselLocal(items) // Keep for backward compatibility
            return items
        } catch (err) {
            console.error(err)
            return null
        }
    }
}
